import React from "react";
import { Card, Alert } from "react-bootstrap";

function CreatingRunbooks() {
  return (
    <div>
      <h2 className="mb-4">Creating & Editing Runbooks</h2>

      <Alert variant="info">
        This guide explains how to create new runbooks and edit existing ones using the Workflow Builder.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>Creating a New Runbook</h4>
          <ol>
            <li>Go to <strong>My Runbooks</strong></li>
            <li>Click the <strong>Add Runbook</strong> button</li>
            <li>Fill in the runbook details:
              <ul className="mt-2">
                <li><strong>Name</strong> - A unique identifier for your runbook</li>
                <li><strong>Description</strong> - What the runbook does</li>
                <li><strong>Category</strong> - Organizational grouping</li>
                <li><strong>Server</strong> - Which runbook server will execute it</li>
                <li><strong>Debug Mode</strong> - Enable for detailed logging</li>
              </ul>
            </li>
            <li>Click <strong>Save</strong></li>
            <li>Click <strong>Workflow</strong> to open the Workflow Builder and design your runbook</li>
          </ol>
          <p className="mt-3">
            <em>Note: You need the "runbooks.create" permission to create runbooks.</em>
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Editing an Existing Runbook</h4>
          <ol>
            <li>Go to <strong>My Runbooks</strong></li>
            <li>Select the runbook you want to edit</li>
            <li>Click the <strong>Edit</strong> button</li>
            <li>Make your changes to the runbook properties</li>
            <li>Click <strong>Save</strong></li>
            <li>To edit the workflow, click <strong>Workflow</strong> to open the Workflow Builder</li>
          </ol>
          <p className="mt-3">
            <em>Note: You need the "runbooks.edit" permission to edit runbooks.</em>
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Email Notifications</h4>
          <p>
            You can configure email notifications to be sent when a runbook execution completes. Enter one or more
            email addresses (comma-separated) in the notification field when creating or editing a runbook.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Debug Mode</h4>
          <p>
            When debug mode is enabled, the runbook will generate detailed logs during execution. This is helpful
            for troubleshooting issues but may slow down execution slightly.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Runbook Validation</h4>
          <p>
            Before a runbook can be executed, it must be validated. Validation checks that:
          </p>
          <ul>
            <li>All required fields are filled in</li>
            <li>The workflow has at least one step</li>
            <li>All connectors and variables referenced in the workflow exist</li>
            <li>The workflow structure is valid</li>
          </ul>
          <p className="mt-3">
            To validate a runbook manually:
          </p>
          <ol>
            <li>Select the runbook in My Runbooks</li>
            <li>Click the <strong>Validate</strong> button</li>
            <li>Check the results to see if any issues were found</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Next Steps</h4>
          <p>
            Once you've created a runbook, learn how to design workflows in the <strong>Workflow Builder</strong> guide.
          </p>
        </Card.Body>
      </Card>
    </div>
  );
}

export default CreatingRunbooks;
